import * as React from 'react';
import { SpaceContainerStyles } from '../../style/SpaceContainerStyles';

export interface SpaceProps {
  renderMasthead: () => JSX.Element;
  renderContent: () => JSX.Element;
}

export function Space(props: SpaceProps): React.ReactElement<SpaceProps> {
  return (
    <div className={ SpaceContainerStyles.SpaceContainer }>
      <div className={ SpaceContainerStyles.MastheadArea }>
        {props.renderMasthead()}
      </div>
      <div className={SpaceContainerStyles.SubplaceArea}>
        {props.renderContent()}
      </div>
    </div>
  );
}
